(function () {
  document.querySelectorAll('.section-popup-header,.section-popup-banner').forEach(section => {
    const description = section.querySelector('.popup-description');

    if (!description) {
      return;
    }

    const more = section.querySelector('.popup-more');
    const isClamped = description.scrollHeight > description.clientHeight;

    if (!isClamped) {
      more.classList.add('hidden');
      return;
    }

    more.classList.remove('hidden');

    more.querySelector('.more-toggle').addEventListener('click', (e) => {
      e.preventDefault();
      more.classList.add('hidden');
      description.classList.add('show');
    });
  });
}());
